import Vue from 'vue';
import Router from 'vue-router';
// import HelloWorld from '@/components/HelloWorld';
import home from '@/components/home';
import pro from '@/components/pro';
import about from '@/components/about';
import academy from "@/components/academy";
import contact from "@/components/contact";
import talents from "@/components/talents";
import build from "@/components/build";
import refer from "@/components/refer";
import term from "@/components/term";
import faq from "@/components/faq";
import policy from "@/components/policy";
import portfolio from "@/components/portfolio";
import project from "@/components/project";
import talent from "@/components/talent";
import payment from "@/components/payment";
import webdevelopment from "@/components/webdevelopment";
import mobiledevelopment from "@/components/mobiledevelopment";
import datascience from "@/components/datascience";
import productdesign from "@/components/productdesign";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    
    {
      path: '/pro',
      name: 'pro',
      component: pro
    },

    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/academy',
      name: 'academy',
      component: academy
    },    
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },    
    {
      path: '/talents',
      name: 'talents',
      component: talents
    },
    {
      path: '/build',
      name: 'build',
      component: build
    },
    {
      path: '/refer',
      name: 'refer',
      component: refer
    },

    {
      path: '/term',
      name: 'term',
      component: term
    },
    
    {
      path: '/faq',
      name: 'faq',
      component: faq
    },
    
    {
      path: '/policy',
      name: 'policy',
      component: policy
    },
    
    {
      path: '/portfolio',
      name: 'portfolio',
      component: portfolio
    },
    
    {
      path: '/project',
      name: 'project',
      component: project
    },
    
    {
      path: '/talent',
      name: 'talent',
      component: talent
    },
    
    {
      path: '/payment',
      name: 'payment',
      component: payment
    },
    
    {
      path: '/webdevelopment',
      name: 'webdevelopment',
      component: webdevelopment
    },
    
    {
      path: '/mobiledevelopment',
      name: 'mobiledevelopment',
      component: mobiledevelopment
    },
    
    {
      path: '/datascience',
      name: 'datascience',
      component: datascience
    },
    
    {
      path: '/productdesign',
      name: 'productdesign',
      component: productdesign
    }
  ],
  // scrollBehavior (to, from, savedPosition) {
  //   return {x:0,y:-900};
  // }
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js